import React from 'react'

const Message = ({message}) => {
  return (
    <article className="slds-card">
      <div className="slds-card__header slds-grid">
        <header className="slds-media slds-media--center slds-has-flexi-truncate">

          <div className="slds-media__figure">
            <span className="slds-avatar slds-avatar--circle slds-avatar--medium">
              <img src={message.profile_image} alt={message.name} />
            </span>
          </div>
        
          <div className="slds-media__body">
            <h3 className="slds-page-header__title slds-m-right--small slds-align-middle slds-truncate" title={message.formated_name} >
              {message.formated_name}
            </h3>
            <p className="slds-text-title--caps slds-line-height--reset">
              {message.network}&mdash; {message.location}
            </p>
          </div>
        </header>
      </div>
      <div className="slds-card__body">
        <div className="slds-grid slds-m-horizontal--medium">
          <div className="slds-col slds-has-flexi-truncate">
            <p className="slds-text-title--caps slds-line-height--reset" style={{zindex: '-1'}} >
            </p>
          </div>
        </div>
      </div>
    </article>
  )
}

export default Message